import styles from './successModal.module.scss';
import Modal from 'src/components/modal/Modal';
import Button from 'src/components/button/Button';

type Props = {
  open: boolean;
  studyPlan?: string;
  onClose: () => void;
  onSuccess: () => void;
};

function SuccessModal(props: Props) {
  const { open, studyPlan, onSuccess } = props;

  return (
    <Modal global={false} open={open} onClose={() => {}} className={styles.wrapper} closeButton={false}>
      <div>
        <div className={styles.header}>
          <div className={styles.title}>Success! {studyPlan}'s Study Plan is Activated.</div>
        </div>
        <div className={styles.content}>
          <span>You can now give {studyPlan} access to this page.
          {studyPlan} will only have access to Lessons that are from this Unit.</span>
          <span>Your Account Password will be required to return to your dashboard.</span>
         
          <div className={styles.action}>
            <Button size="small" className={styles.okButton} onClick={onSuccess} label={'Continue'}/>
          </div>
        </div>
      </div>
    </Modal>
  );
}

export default SuccessModal;
